<template>
  <b-row align-h="between" no-gutters="">
    <b-col
      v-for="dataKey in Object.keys(dataMeta)"
      :key="dataKey"
      :cols="dataMeta[dataKey].cols"
      :sm="dataMeta[dataKey].sm"
      :md="dataMeta[dataKey].md"
      :lg="dataMeta[dataKey].lg"
      :xl="dataMeta[dataKey].xl"
      :class="dataMeta[dataKey].classes"
    >
      <div v-if="data[dataKey] !== undefined">
        <i
          v-if="dataKey == 'state'"
          :class="computedSelectColor"
          class="stacked icons"
        >
          <i id="circle" class="circle icon m-auto" />
          <i id="outline" class="circle outline icon" />
        </i>
        <a v-else-if="dataMeta[dataKey].href" :href="data[dataKey]">
          {{ "components.softwares.softwareListEntry.details" | i18n }}
        </a>
        <p v-else>
          {{ data[dataKey] }}
        </p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
/**
 * @description Affiche une entrée de liste de logiciels, formatée selon le parent.
 * Supporte de façon exceptionnelle le statut, puisqu'il se retrouve dans la plupart
 * des listes de logiciels.
 * @author Félix Bordage
 * @vue-prop {Object} dataMeta - Données servant à formater l'entrée
 * @vue-prop {Object} data - Données de l'entrée
 * @vue-computed {String} computedSelectColor - Détermine la couleur du statut du logiciel
 */
export default {
  name: "SoftwareListEntry",
  props: {
    dataMeta: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedSelectColor() {
      return this.data.state == 0
        ? "text-danger"
        : this.data.state == 1
        ? "text-warning"
        : this.data.state == 2
        ? "text-success"
        : "text-light";
    }
  }
};
</script>

<style scoped lang="scss">
#circle {
  font-size: 16px;
}

#outline {
  font-size: 24px;
}
</style>
